import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useIsUpsellScreenEnabled } from '../../hooks';
import { useReorderNavigation } from '../../hooks/useReorderNavigation';
import { Customization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationScreen = () => {
  const router = useRouter();
  const routeParams = useLocalSearchParams<CustomizationScreenRouteParams>();

  const { restaurantSlug, productSlug, reorderLineItemId, sharedLineItemId } = routeParams;

  const { finishReorder } = useReorderNavigation();
  const isUpsellScreenEnabled = useIsUpsellScreenEnabled();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (sharedLineItemId) {
      finishReorder(restaurantSlug);
      return;
    }

    if (isUpsellScreenEnabled) {
      router.replace('/upsell');
      return;
    }

    router.replace({ pathname: '/bag', params: { referrer: 'Menu' } });
  }, [finishReorder, isUpsellScreenEnabled, restaurantSlug, router, sharedLineItemId]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Customization
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      onAddLineItemToCart={handleAddLineItemToCart}
      reorderLineItemId={reorderLineItemId}
      sharedLineItemId={sharedLineItemId}
      isEditProductMode={false}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationScreenRouteParams = {
  restaurantSlug: string;
  productSlug: string;
  reorderLineItemId?: string;
  sharedLineItemId?: string;
};
